export const NEOSACCOUNT_API_URL = process.env.NEOSACCOUNT_API_URL || "";
export const NEOSCRM_URL = process.env.NEOSCRM_URL || "";
export const NEOSGOAL_TENANT_URL = process.env.NEOSGOAL_TENANT_URL || "";
export const STRIPE_KEY = process.env.STRIPE_KEY || "";
